export default __webpack_public_path__ + "static/media/sprite.48e5f672.png";